import { useEffect, useRef, useState } from "react";
import "../assets/styles/Advertisement.css";
import { getRandomAd } from "../functions/api";
import generateAddressImg from "../functions/generateAddressImg";

export default function Advertisement({ slot, page = "", node = "" }) {
  const [ad, setAd] = useState();
  const imageRef = useRef(0);
  const [size, setSize] = useState(window.innerWidth);
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (error) {
      console.error(error);
    }
  }, [page, node, slot]);

  const loadData = async () => {
    if (!slot && !ad) {
      const apiResponse = await getRandomAd({ node, page });
      if (apiResponse?.code == 0) {
        setAd(apiResponse.data);
      }
    }
  };
  useEffect(() => {
    window.addEventListener("resize", () => {
      setSize(window.innerWidth);
    });
    return () => {
      window.removeEventListener("resize", () => {
        setSize(window.innerWidth);
      });
    };
  }, []);
  loadData();

  const rightSideAdStyle = {
    position: "fixed",
    top: 145,
    right: "1.5%",
    height: "auto",
    width: "10%",
    display: size > 1500 ? "block" : "none",
  };
  const textStyles = {
    position: "relative",
    backgroundColor: "rgba(255, 255, 255, 0.5)",
    width: "100%",
    paddingRight: "10%",
    paddingLeft: "10%",
    textAlign: "center",
  };
  return (
    <>
      {(ad?.code || ad?.imgs?.[0]) && (
        <>
          {slot || ad.code ? (
            <div
              className="text-center"
              style={node == 2 ? rightSideAdStyle : { width: "100%" }}
            >
              <ins
                className="adsbygoogle infeed"
                style={{ display: "block" }}
                data-ad-client="ca-pub-9140791068839294"
                data-ad-slot={slot || ad.code}
                data-ad-format="fluid"
                data-full-width-responsive="true"
              ></ins>
            </div>
          ) : (
            <div
              ref={imageRef}
              style={node == 2 ? rightSideAdStyle : { position: "relative" }}
            >
              {ad.link ? (
                <a href={ad.link} target="_blank" className="text-dark d-flex flex-column align-items-center">
                  <img
                    alt={ad.title}
                    src={generateAddressImg(ad.imgs[0]?.path, 0, 0)}
                    className="img-fluid"
                  />
                  {ad.text && (
                    <div style={textStyles} className="ad-text">
                      <span>{ad.text}</span>
                    </div>
                  )}
                </a>
              ) : (
                <div className="d-flex flex-column align-items-center">
                  <img
                    alt={ad.title}
                    src={generateAddressImg(ad.imgs[0]?.path, 0, 0)}
                    className="img-fluid"
                  />
                  {ad.text && (
                    <div style={textStyles} className="ad-text">
                      <span>{ad.text}</span>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </>
      )}
    </>
  );
}
